import type { ProductHintsCardFragmentFragment } from '@packages/gql/generated/shopping/graphql';

/* istanbul ignore file */
import { makeFragmentData } from '@packages/gql/generated/shopping';
import { ProductHintsCardFragmentFragmentDoc } from '@packages/gql/generated/shopping/graphql';
import { productHintsItemDataMock } from '../ProductHintsItem/mockdata';

export const productHintsCardDataMock: ProductHintsCardFragmentFragment = {
  productHints: [productHintsItemDataMock, productHintsItemDataMock],
};

export function getProductHintsCardFragmentedData(data?: ProductHintsCardFragmentFragment) {
  return makeFragmentData(data || productHintsCardDataMock, ProductHintsCardFragmentFragmentDoc);
}
